import type { RoleType, UserStatus } from '@hit-game/shared/enums';
import type { INotificationPreferences, IUser } from '@hit-game/shared/types';

import { http, type Paginated } from '../lib/http';

export interface UserListParams {
  page?: number;
  limit?: number;
  search?: string;
  role?: RoleType;
}

export interface CreateUserInput {
  username: string;
  password: string;
  note?: string;
  role?: RoleType;
}

export const userService = {
  list(params: UserListParams): Promise<Paginated<IUser> & { totalCount: number }> {
    return http.get('/users', { params });
  },

  detail(id: string): Promise<IUser> {
    return http.get(`/users/${id}`);
  },

  create(input: CreateUserInput): Promise<IUser> {
    return http.post('/users', input);
  },

  update(id: string, data: Pick<Partial<IUser>, 'note'>): Promise<IUser> {
    return http.patch(`/users/${id}`, data);
  },

  updatePassword(id: string, password: string): Promise<null> {
    return http.patch(`/users/${id}/password`, { password });
  },

  updateStatus(id: string, status: UserStatus): Promise<IUser> {
    return http.patch(`/users/${id}/status`, { status });
  },

  updateRole(id: string, role: RoleType): Promise<IUser> {
    return http.patch(`/users/${id}/role`, { role });
  },

  getNotificationPreferences(): Promise<INotificationPreferences> {
    return http.get('/users/notification-preferences');
  },

  updateNotificationPreferences(
    prefs: Partial<INotificationPreferences>,
  ): Promise<INotificationPreferences> {
    return http.put('/users/notification-preferences', prefs);
  },
};
